<template>
  <div class="category-filter">
    <div class="filter-header">
      <!-- style="color: white;" -->
      <h3 >{{ $t('Categories') }}</h3>
      <div v-if="selectedCategoryNames.length" class="selected-row">
        <!-- <strong>Selected:</strong> -->
         <!-- style="color: white;" -->
        <span  v-for="name in selectedCategoryNames" :key="name">
          {{ name }}
        </span>
        <!-- color="white" -->
        <v-btn  small text @click="clearCategories">
          {{ $t('Clear') }}
        </v-btn>
      </div>
    </div>
    <v-row class="categories-scroll" no-gutters>
      <div :class="{ active: selectedCategoryIds.includes(String(item.id)) }"
      v-for="item in sortedCategories" :key="item.id" @click="selectCategory(item.id)" class="toolbar-cat">
        <div>
          <v-img class="toolbar-img-cat" :src="getImgUrl(item.image)" v-if="item.image" />
          <!-- :style="!selectedCategoryIds.includes(String(item.id)) ? 'color: white;' : ''" -->
          <v-icon  v-else class="toolbar-img-cat">
            mdi-database-outline
          </v-icon>
        </div>
        <h5>{{ item.name }}</h5>
      </div>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters, } from 'vuex'
export default {
  name: 'CategoryFilter',
  computed: {
    ...mapGetters({
      categories: 'categories/getCategories',
    }),
    selectedCategoryIds() {
      return [].concat(this.$route.query.category_id || []).map(String)
    },
    sortedCategories() {
      return [...this.categories].sort((a, b) => {
        const aSelected = this.selectedCategoryIds.includes(String(a.id))
        const bSelected = this.selectedCategoryIds.includes(String(b.id))

        if (aSelected === bSelected) return 0
        return aSelected ? -1 : 1
      })
    },
    selectedCategoryNames() {
      const selected = [].concat(this.$route.query.category_id || [])
      return this.categories
        .filter(c => selected.includes(String(c.id)))
        .map(c => c.name)
    },
  },
  methods: {
    ...mapActions({
      fetchCategories: "categories/fetchCategories",
    }),
    selectCategory(id) {
      const current = this.$route.query.category_id ? [].concat(this.$route.query.category_id) : [];
      let newCategories;
      if (current.includes(String(id))) {
        newCategories = current.filter(c => c !== String(id));
      } else {
        newCategories = [...current, id];
      }
      this.$router.push({query: {...this.$route.query,category_id: newCategories.length ? newCategories : undefined}});
    },
    clearCategories() {
      const query = { ...this.$route.query }
      delete query.category_id
      this.$router.push({ query })
    },
    getImgUrl(item) {
      let domain = `${this.$store.state.serverDomain}/storage/`;
      return domain + item;
    },
  },
  created() {
    if(this.categories.length==0)
    this.fetchCategories({paginated: false});
  }
}
</script>

<style scoped>

.toolbar-cat.active {
  background-color: #e8f5e9;
  border: 2px solid #4caf50;
  color: #2e7d32;
}

.categories-scroll {
  display: flex;
  flex-wrap: nowrap;     
  overflow-x: auto;       
  overflow-y: hidden;
  gap: 12px;
  padding: 10px 0;
}



.categories-scroll {
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

}

.categories-scroll::-webkit-scrollbar {
  display: none;
}

.toolbar-cat {
  flex: 0 0 auto;
  /* color: white; */
  height: 80px;
  width: 80px;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s;
}

.toolbar-img-cat {
  height: 60px;
  width: 70px;
  border-radius: 15px;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.5s;
}

.category-filter {
  /* background: white; */
  /* background: linear-gradient(135deg, #5a6a8a, #364359); */

  padding: 20px;
  /* border-radius: 12px; */
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.1); */
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.filter-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.clear-btn {
  background: none;
  border: 1px solid #ddd;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
}

.clear-btn:hover {
  background: #f8f9fa;
  border-color: #999;
}

.categories {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.category-btn {
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
  transition: all 0.3s ease;
}

.category-btn:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.category-btn.active {
  background: #2ed573;
  color: white;
  border-color: #2ed573;
}
</style>